<template>
  <div class="col-12 box-col-6">
    <div class="email-left-aside">
      <b-overlay :show="isLoading" rounded="sm">
        <b-card no-body>
          <b-card-header header-class="border-0 cardHeaderInfo p-b-0">
            <div v-html="$t('lbl_EMPBE_OtherContactHeaderInfo')"></div>
          </b-card-header>
          <b-tabs card @input="onInput">
            <div>
              <b-tab active :title='$t("Lbl_ProductInfo")'
                :title-link-attributes="{ 't_label': 'EMPBE_ProductInfoCenter_tab_Product' }">
                <div class="email-app-sidebar left-bookmark" style="height: auto">
                  <div class="media"></div>
                  <ul class="nav main-menu col-12" role="tablist">
                    <li class="nav-item">
                      <productGrid :addToCart="addToCart" :Records="productList" :otherInfo="otherInfo"
                        @refreshGrid="fetchData"></productGrid>
                    </li>
                  </ul>
                </div>
              </b-tab>
              <b-tab :title-item-class="{ 'd-none': !isShowCatalog }" :title='$t("lbl_EMPBE_ProductIndex")'
                :title-link-attributes="{ 't_label': 'EMPBE_ProductInfoCenter_tab_Info' }">
                <div class="email-app-sidebar left-bookmark" style="height: auto">
                  <div class="media"></div>
                  <ul class="nav main-menu col-12" role="tablist">
                    <li class="nav-item">
                      <visitorPermission :Permission="isShowCatalog">
                        <template v-slot:body>
                          <catalogGrid :addToCart="addToCart" :Records="indexList" :otherInfo="otherInfo"></catalogGrid>
                        </template>
                      </visitorPermission>
                    </li>
                  </ul>
                </div>
              </b-tab>
            </div>
          </b-tabs>
        </b-card>

      </b-overlay>
      <b-sidebar id="OrderRightpopup" class="customSidebar" title="" right bg-variant="white" :shadow="true" backdrop
        :visible="false" ref="OrderRightpopup">
        <productOrdering :currentTab="currentTab" :productList="productList" :indexList="indexList"></productOrdering>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { productService } from '@/_services/product.service';
import productOrdering from './productOrdering.vue'
import productGrid from './productGrid.vue';
import catalogGrid from './catalogGrid.vue';

export default {
  inject: ['permissionData'],
  props: ['hideSidebarNavMenu'],
  components: {
    productOrdering: productOrdering,
    productGrid: productGrid,
    catalogGrid: catalogGrid
  },
  data() {
    return {
      isShowCatalog: true,
      isProductListLoading: true,
      isProductCatalogLoading: true,
      items: null,
      error: null,
      productList: [],
      indexList: [],
      otherInfo: {
        product_PayTotalQty: 0,
        product_TotalQty: 0,
        product_LaunchedCount: 0,
        directory_PayTotalQty: 0,
        directory_TotalQty: 0,
        directory_LaunchedCount: 0,
      },
      currentTab: 0
    };
  },
  computed: {
    ...mapGetters({
      getPaymentItemById: 'paymentItem/getPaymentItemById',
      getCartPaymentItemById: 'paymentItem/getCartPaymentItemById',
    }),
    langid() {
      return localStorage.getItem("currentLangId")
    },
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.user.empCompanyId;
    },

    isLoading() {
      // Check the current tab and return the loading status of the tab
      return this.currentTab === 0
                ? this.isProductListLoading
                : this.currentTab === 1
                ? this.isProductCatalogLoading
                : false;
    },
  },
  created() {
    // watch the params of the route to fetch the data again
    this.$watch(
      () => this.$route.params,
      () => {
        if (!this.fetchedData) {
          this.fetchData();
          this.productListDragula();
        }
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
    this.initData();
    this.initPermissionData();
  },
  watch: {
    permissionData: {
      handler() {
        this.initPermissionData();
      },
      deep: true
    }
  },
  mounted() {
    // 监听子组件的刷新事件
    this.$on('fetchData', this.fetchData);
  },
  methods: {
    initPermissionData() {
      if (this.permissionData != null) {
        this.isShowCatalog = this.permissionData['Type'] == 'A' || this.permissionData['Type'] == 'B';
      }
    },
    initData() {
      var that = this;
      productService.getSysAccountPaymentInfo({ CompanyId: this.companyid, demodate: '' }).then((res) => {
        if (res.isSuccessful) {
          console.log('res.data');
          console.log(res.data);
          if (res.data != null) {
            let data = res.data;
            if (data.length > 0) {
              data.forEach(element => {
                if (element.rid === 1) {
                  that.otherInfo.product_PayTotalQty = element.payTotalQty;
                  that.otherInfo.product_TotalQty = element.totalQty;
                }
                if (element.rid === 2) {
                  that.otherInfo.directory_PayTotalQty = element.payTotalQty;
                  that.otherInfo.directory_TotalQty = element.totalQty;
                }
              });
            }
          }

        }
      });
    },
    productListDragula() {
      let dragula = this.$dragula;
      let service = dragula.createService({
        name: 'product',
        drake: {
          copy: true,
        },
      });
      service.on({
        'product:dropModel': ({
          name,
          el,
          source,
          target,
          dragIndex,
          dropIndex,
          sourceModel,
        }) => {
          el.classList.add('ex-moved');
          if (name == 'product' && dragIndex != dropIndex) {
            var productId = el.attributes.id.value;
            productService
              .saveProdutDetailIndex({
                companyId: this.companyid,
                productId: productId,
                old_index: dragIndex,
                new_index: dropIndex,
              })
              .then((res) => {
                if (res.isSuccessful) {
                  this.$swal({
                    text: this.$t('lbl_EMPBE_ChangeProdOrder'),
                  });
                }
              });
          }
          if (name == 'index' && dragIndex != dropIndex) {
            var catalogId = el.attributes.id.value;
            productService
              .saveProdutCatalogDetailIndex({
                companyId: this.companyid,
                catalogId: catalogId,
                old_index: dragIndex,
                new_index: dropIndex,
              })
              .then((res) => {
                if (res.isSuccessful) {
                  this.$swal({
                    text: this.$t('lbl_EMPBE_ChangeIndexOrder'),
                  });
                }
              });
          }
        },
      });
    },
    fetchData() {
      this.error = this.items = null;
      this.isProductListLoading = true;
      this.isProductCatalogLoading = true;
      this.fetchedData = true;
      this.loadData();
    },
    loadData() {
      console.log('getProdutListAsync')
        var that = this;
        //获取数据
        this.productList = [];
        productService
          .getProdutListAsync({ companyId: this.companyid })
          .then((res) => {
            if (res.isSuccessful) {
              this.productList = [];
              this.otherInfo.product_LaunchedCount = 0;
              res.data.forEach((item) => {
                var _item = {
                  id: item.productId,
                  name: this.langid == "1252" ? item.exhibitNameE : item.exhibitNameS,
                  IsLaunch: item.isLaunch,
                  isFire: item.isMainProduct,
                  EmpCompanyId: item.empCompanyId,
                  OrderId: item.orderId,
                  productId: item.productId,
                  lastSubmitDate: item.lastSubmitDate,
                  lastSaveDate: item.lastSaveDate
                };
                if (_item.name == "") {
                  _item.name = this.langid == "1252" ? item.exhibitNameS : item.exhibitNameE
                }
                if (_item.IsLaunch) {
                  this.otherInfo.product_LaunchedCount += 1;
                }
                this.productList.push(_item);
              });
            }
          })
          .finally(() => {
            this.isProductListLoading = false;
          });
        //获取产品目录列表
        this.indexList = [];
        productService
          .getProdutCatalogListAsync({ companyId: this.companyid })
          .then((res) => {
            console.log(res);
            if (res.isSuccessful) {
              this.indexList = [];
              this.otherInfo.directory_LaunchedCount = 0; 

              var currentLangData = res.data.filter(x => x.name != '' && x.langId == that.langid)
              currentLangData.forEach((item) => {

                if (item.isLaunch) {
                  this.otherInfo.directory_LaunchedCount += 1;
                }
                
                var _item = {
                  id: item.catalogId,
                  langid: item.langId,
                  name: item.name,
                  statusClass: item.isLaunch
                    ? 'badge-light-success'
                    : 'badge-light',
                  orederId: item.orderId,
                  spanIsLaunch: item.isLaunch,
                  lastSaveDate: item.saveDate,
                  lastSubmitDate: item.submitDate
                };
                this.indexList.push(_item);
              });

              res.data.forEach((item) => {

                 
                var _item = {
                  id: item.catalogId,
                  langid: item.langId,
                  name: item.name,
                  statusClass: item.isLaunch
                    ? 'badge-light-success'
                    : 'badge-light',
                  orederId: item.orderId,
                  spanIsLaunch: item.isLaunch,
                  lastSaveDate: item.saveDate,
                  lastSubmitDate: item.submitDate
                };
                var that = this;
               
                if (this.indexList.filter(x => x.id == _item.id).length <= 0) {
                  this.indexList.push(_item);
                }
              });
              console.log('indeli', this.indexList);
            }
          })
          .finally(() => {
              this.isProductCatalogLoading = false;
          });
    },
    //Add to cart
    addToCart: function (sku, qty) {
      //close right popup
      this.hideSidebarNavMenu();

      var product = this.getCartPaymentItemById(sku);
      if (product != undefined) {
        this.$store.dispatch('paymentItem/updateCartQuantity', {
          product: product,
          qty: 1,
        });
      } else {
        product = this.getPaymentItemById(sku);
        product.quantity = qty ? qty : 1;
        this.$store.dispatch('paymentItem/addToCart', product);
      }
      this.cart_open();
    },
    cart_open() {
      this.$store.dispatch('paymentItem/toggleCart', true);
    },
    onInput(value) {
      this.currentTab = value;
    }
  },
};
</script>
<style>
/* .card .router-link-exact-active {
  background-color: #e2e2e2;
  text-decoration: none;
} */

.no-router-link-exact-active {
  background-color: unset !important;
}

.export-buttons {
  margin-left: auto;
  margin-right: 0;
}

b-tab .d-none {
  display: none !important;
}
</style>